import "../styles/base.css";

export function Landing() {
  return <div className="base-container"></div>;
}
export default Landing;
